export function formatDate(date) {
    if (date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}-${month}-${year}`;
    }
    return "";
}

export function initPeopleObj() {
    return {
        name: '',
        surname: '',
        dob: '',
        phone: '',
    }
}

export function getMaxDate() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 16);
    return date.toISOString().split("T")[0];
}

export function isDuplicatePhoneNumber(phone, duplicatePhoneNumbers, originalPhone = null) {
    const last10 = phone.slice(-10);
    const originalLast10 = originalPhone ? originalPhone.slice(-10) : null;
    
    return duplicatePhoneNumbers
    .filter(p => p.slice(-10) !== originalLast10)
    .some(p => p.slice(-10) === last10);
}

export function isValidPhoneNumber(phone) {
    const phonePattern = /^07\d{9}$/;
    const cleaned = phone.replace(/[^0-9]/g, '');
    return phonePattern.test(cleaned);
}

export function isFieldEmpty(value) {
    return !value || value.trim() === "";
}

//validatePhone = true for using in CMS to validate for now, customer flow is currently doing it via vee-validate
export function validateAdditionalPeopleInput(person, accountHolderPhoneNumber, validatePhoneAndDob = true) { 
    if (person.phone && person.phone.startsWith('+44')) {
        person.phone = person.phone.replace('+44', '0')
    }

    const phonePattern = /^07\d{9}$/;

    if(!person.name || !person.surname) {
        return {
            valid: false,
            errorMsg: "Invalid name in Additional Members",
            type: 'noName'
        }
    }

    if(validatePhoneAndDob) {
        if (!person.phone) {
            return {
                valid: false,
                errorMsg: "No phone number",
                type: 'noPhone'
            }
        }
        
        if(!phonePattern.test(person.phone)) {
            return {
                valid: false,
                errorMsg: "Invalid Phone Number in Additional Members",
                type: 'invalidNumber'
            }
        }

        if (person.phone == accountHolderPhoneNumber) {
            return {
                valid: false,
                errorMsg: "Additional Members phone number is the same as account holder",
                type: 'sameNumberAsAccountHolder'
            }
        }

        if(!person.dob){
            return {
                valid: false,
                errorMsg: "Missing Date of Birth",
                type: 'invalidDob'
            }
        }
        
        if(dateValidator(person.dob) === false){
            return {
                valid: false,
                errorMsg: "Invalid Date of Birth",
                type: 'invalidDob'
            }
        }
    }

    return {
        valid: true,
        errorMsg: "Success",
        type: 'success'
    }
   
}

import moment from 'moment';
    export function dateValidator(dateOfBirth) {
        
        const [year, month, day] = dateOfBirth.split('-');
        
        
        if (day && month && year >= 1900) {
        const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        let isLeapYear = moment([year]).isLeapYear();
        if (isLeapYear) monthLength[1] = 29;

        if (month < 1 || month > 12) {
            return false;
        }

        if (day < 1 || day > monthLength[month - 1]) {

            return false;
        }

        const inputDate = moment({ year, month: month - 1, day });
        const today = moment();

        if (inputDate.isAfter(today, 'day')) {
            return false;
        }
        
        return true;
    } else {
        return false;
    }
}


export const formatPhoneNumber = (number) => {
    if (!number) return '';

    number = number.replace(/ /g, '');

    number = number.replace(/^(\+)/, '');
    number = number.replace(/^(00)/, '');
    number = number.replace(/^(44)/, '');

    if (!/^0/.test(number)) {
        number = '0' + number;
    }

    return number;
};